import deepmerge from 'deepmerge';
import {ENVIRONMENT_GLOBAL} from '../global_env';
//TODO
export const environment = deepmerge(ENVIRONMENT_GLOBAL, {
  envName: 'test',
 production: true,
 appVersion: require('../../../package.json').version + '-test',
  redirect: {
    host: 'https://testadmin-patchmanagement.securiton.de'
  },
  auth_L1: {
    client_id: 'patchmanagement-admin-ui',
    scope: 'phone email profile openid',
    endpoint: {
      host: 'https://testaccount-my.securiton.de',

      paths: {
        prefix: '/auth/realms/securicloud',
      },
    },
  },
  backend: {
    scope: 'spm',
    client_id: 'spm-admin-webapp-X4sGm1vQe7Az9KbP',
    endpoint: {
      host: 'https://testapi-my.securiton.de',
    },
  },
});
